import useUrlState from '@ahooksjs/use-url-state';
import { useLocalStorageState, useRequest, useSessionStorageState } from 'ahooks';
import { Form, notification } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import APIFunction from '@/service';
import { getHrefParam, isMobile } from '@/utils';

import Mobile from './mobile';
import PC from './pc';

const LoginComponent = isMobile() ? Mobile : PC;

function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loginState, setLoginState] = useSessionStorageState('FEISHU_LOGIN_STATE');
  const [params, setParams] = useUrlState<{
    redirect?: string;
    code?: string;
    state?: string;
    from?: string;
  }>({});
  const [, setToken] = useLocalStorageState(`JOY_ADMIN_${import.meta.env.VITE_APP_ENV}_TOKEN`, {
    defaultValue: '',
  });
  const [, setAdminInfo] = useLocalStorageState(
    `JOY_ADMIN_${import.meta.env.VITE_APP_ENV}_USER_INFO`,
    {}
  );

  const loginSuccess = useCallback(
    (loginRes: any) => {
      setToken(loginRes.token);
      setAdminInfo(loginRes.user);
      if (params.from && params.from === 'individual') {
        if (params.redirect.indexOf('?') >= 0) {
          window.location.href = encodeURI(`${params.redirect}&token=${loginRes.token}`);
        } else {
          window.location.href = encodeURI(`${params.redirect}?token=${loginRes.token}`);
        }
      } else {
        if (params.redirect) {
          navigate(encodeURI(params.redirect));
        } else {
          navigate('/');
        }
      }
    },
    [setToken, setAdminInfo, params.from, params.redirect, navigate]
  );

  const { run: outerEmailLogin, loading: emailLoginLoading } = useRequest(
    (data) => APIFunction.outerEmailLogin(data),
    {
      manual: true,
      onSuccess(e) {
        loginSuccess(e);
      },
      onError(e: any) {
        // 检查是否是 40002 错误码（密码超过3个月未修改）
        const code = e?.response?.data?.data?.code;
        const msg = e?.response?.data?.data?.msg;
        if (code === 40002 && msg) {
          // 使用 antd notification 常驻提示，显示在顶部，duration=0 不自动关闭，用户可手动点 x 关闭
          notification.warning({
            key: 'password-expired',
            message: '密码过期',
            description: msg,
            duration: 0,
            placement: 'top',
          });
        }
      },
    }
  );

  const { run: innerLarkLogin, loading: larkLoginLoading } = useRequest(
    (code) => APIFunction.innerLarkLogin({ code }),
    {
      manual: true,
      onSuccess(e) {
        loginSuccess(e);
      },
      onError(e) {
        if (params?.redirect) {
          setParams({
            redirect: params.redirect,
            code: undefined,
            state: undefined,
          });
        } else {
          setParams({
            code: undefined,
            state: undefined,
          });
        }
      },
    }
  );

  const handlelogin = useCallback(
    async (data) => {
      await outerEmailLogin(data);
    },
    [outerEmailLogin]
  );

  const onClickLarkLogin = useCallback(() => {
    window.location.assign(
      `https://open.feishu.cn/connect/qrconnect/page/sso/?redirect_uri=${encodeURIComponent(
        window.location.origin + window.location.pathname + window.location.search
      )}&app_id=${import.meta.env.VITE_APP_FEISHU_APP_ID}`
    );
  }, []);

  // useEffect(() => {
  //   if(/Feishu/gi.test(window.navigator.userAgent) && !loginState) {
  //     setLoginState(true)
  //     onClickLarkLogin()
  //   }
  // }, [loginState, onClickLarkLogin, setLoginState])

  useEffect(() => {
    if (params.code) {
      // 说明是点的飞书登录跳转回来的
      innerLarkLogin(params.code);
    }
  }, [params?.code, innerLarkLogin]);

  return (
    <LoginComponent
      larkLoading={larkLoginLoading}
      loading={emailLoginLoading}
      form={form}
      handlelogin={handlelogin}
      onClickLarkLogin={onClickLarkLogin}
    />
  );
}
export default React.memo(Login);
